import { GoabContainer, GoabButton, GoabSpacer } from "@abgov/react-components";

import { useGenerationForm } from "../../hooks";

export const GenerationInformationSection = () => {
  const { application } = useGenerationForm();

  return (
    <>
      {/*This section only shows after "Generate" is clicked*/}
      <GoabContainer type="non-interactive" mt="l">
        <div className="centered-text">
          <p>Application code:</p>
          <h2>{application!.uniqueApplicationCode}</h2>
          <GoabButton
            type="tertiary"
            trailingIcon="copy"
            mb="l"
            onClick={() => {
              if (application?.uniqueApplicationCode) {
                navigator.clipboard.writeText(
                  application.uniqueApplicationCode
                );
              }
            }}
          >
            Copy code
          </GoabButton>
          <p>An email has also been sent to {application!.email}</p>
        </div>
      </GoabContainer>
      <GoabSpacer vSpacing="l" />
    </>
  );
};
